import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  toggleButtonLabel: 'Select All',
  clientList: [],
};

const measureSquareConfigSlice = createSlice({
  name: 'MeasureSquareConfig',
  initialState: initialState,
  reducers: {
    measureSquareConfigUpdateClientList(state, { payload }) {
      state.clientList = Object.prototype.hasOwnProperty.call(
        payload,
        'clientList'
      )
        ? payload.clientList
        : state.clientList;
    },
    measureSquareConfigUpdateComponent(state, { payload }) {
      state.isLoading = Object.prototype.hasOwnProperty.call(
        payload,
        'isLoading'
      )
        ? payload.isLoading
        : state.isLoading;
      state.toggleButtonLabel = Object.prototype.hasOwnProperty.call(
        payload,
        'toggleButtonLabel'
      )
        ? payload.toggleButtonLabel
        : state.toggleButtonLabel;
    },
  },
});

export const {
  measureSquareConfigUpdateClientList,
  measureSquareConfigUpdateComponent,
} = measureSquareConfigSlice.actions;

export const measureSquareConfigReducer = measureSquareConfigSlice.reducer;
